import React, { useState, useReducer, useEffect, useContext } from "react";
import { makeStyles } from "@material-ui/styles";
import { Paper, Typography } from "@material-ui/core";

export default function DashboardCard(props) {
    const { title, titleIcon, link, action, children, justify, direction, align } = props;
    const useStyles = makeStyles((theme) => ({
      root: {
        width: "100%",
        padding: theme.spacing(1),
        boxShadow: "0px 0px 2px 2px rgba(0, 0, 0, 0.2)",
        "&:hover": {
          boxShadow: "0px 0px 3px 3px rgba(0, 0, 0, 0.4)",
        }
      },
      title: {
        height: 50, 
        padding: 4,
        backgroundColor: "#EEEEEE", 
        boxShadow: "0px 0px 3px 3px rgba(0, 0, 0, 0.2)",
        flex:"0 0 auto", 
        display:"flex",  
        borderTopLeftRadius: 4, 
        borderTopRightRadius: 4,
        alignItems: "center",
        justifyContent: "center",
        zIndex: 50
      },
      content: {
        flex:"1 1 auto", 
        display:"flex",
        flexDirection: "column",
        alignItems: () => { return align || "center" },
        overflow: "auto",
        padding: 8     ,
        marginBottom:4  
      }
    }));
    const classes = useStyles();
    
  
    return (
      <Paper className={classes.root} style={{display:"flex", flexDirection:"column", padding: 0, height: "100%"}}>
        <div className={classes.title}>
          <div style={{flex: "1 1 auto"}}>
            <Typography align="center" noWrap style={{fontWeight: 400}} color="primary" variant="h6">{title}</Typography>
          </div>
          {link && <div style={{flex: "0 0 auto"}}>
            {link}
            </div>}
        </div>
        <div className={classes.content}>
          <div style={{flex:"1 1 auto", display:"flex", flexDirection: direction || "column", justifyContent: justify || "center"}}>
            {children}
          </div>
          {action && 
          <div style={{flex:"0 0 auto"}}>
            {action}
          </div>}
        </div>
      </Paper>
    );
  }
  